import { enableRealityCheckPopup, disableRealityCheckPopup } from '~/components/account/reality-check/ducks/index.js';
import { selectRealityCheckTimeReached } from '~/components/account/reality-check/ducks/selectors.js';
import store, { observeStore } from '~/store/store.js';
import {
	disableJackpotPopup,
	enableJackpotPopup,
	isWinAnimationShownSelector
} from '~/components/casino-shared/inhouse-jackpot/ducks';

const { dispatch } = store;

const NLCPostMessages = (api, basePathname) => {
	dispatch(enableRealityCheckPopup());

	let popupShownDuringLoading = false;
	let gameLoaded = false;
	let popupShown = false;
	let isSpinning = false;

	const onGamePaused = () => {
		dispatch(enableRealityCheckPopup());
		dispatch(enableJackpotPopup());
	};
	const onGameResumed = () => {
		if (!popupShown) {
			dispatch(disableRealityCheckPopup());
			dispatch(disableJackpotPopup());
		}
	};
	const onGameLoaded = () => {
		gameLoaded = true;

		if (!popupShownDuringLoading) {
			dispatch(disableRealityCheckPopup());
			dispatch(disableJackpotPopup());
		}
	};

	const pauseGame = () => {
		if (gameLoaded && isSpinning) {
			api.call('pause');
		} else {
			onGamePaused();
		}
	};

	const resumeGame = () => {
		if (gameLoaded) {
			api.call('resume');
		}
	};

	const popupHandler = showPopup => {
		popupShown = showPopup;
		if (!gameLoaded) {
			popupShownDuringLoading = true;
		}
		if (showPopup) {
			pauseGame();
		} else {
			resumeGame();
		}
	};

	const { unsubscribe } = observeStore(selectRealityCheckTimeReached, popupHandler);

	const { unsubscribe: unsubscribeJackpot } = observeStore(isWinAnimationShownSelector, popupHandler);

	const setUpListeners = () => {
		api.on('ready', () => {
			onGameLoaded();
			gameLoaded = true;
		});

		api.on('busy', () => {
			isSpinning = true;
			onGameResumed();
		});

		api.on('idle', () => {
			isSpinning = false;
			onGamePaused();
		});

		api.on('exit', () => {
			setTimeout(unsubscribe, 0);
			setTimeout(unsubscribeJackpot, 0);
			window.location = basePathname;
			return true;
		});
	};

	setUpListeners();

	return () => {};
};

export default NLCPostMessages;
